function H3(props) {
  const { children } = props;
  return (
    <h3 className="text-2xl font-semibold">{children}</h3>
  );
}

export default H3;
